
import { ItemCompact } from "@/models/ItemCompact";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class vRecipeCategoryPrintout extends Vue {
  @Prop({ default: "" }) readonly categoryName!: string;
  @Prop({ default: (): ItemCompact[] => [] }) readonly recipes!: ItemCompact[];
}
